import React from 'react';
import { COLORS, SPACING } from '../styles/theme';

export function Live() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      padding: SPACING.xl,
      textAlign: 'center',
    }}>
      <div style={{
        border: `2px outset ${COLORS.highlight}`,
        backgroundColor: COLORS.panel,
        padding: SPACING.xxl,
        maxWidth: '420px',
        width: '100%',
      }}>
        <div style={{ fontSize: '48px', marginBottom: SPACING.lg, color: COLORS.accent }}>◉</div>
        <h2 style={{ margin: `0 0 ${SPACING.md} 0`, fontSize: '16px', fontFamily: '"IBM Plex Mono", monospace', fontWeight: 700, fontStyle: 'italic', color: COLORS.accent }}>
          Live — Coming Soon
        </h2>
        <p style={{ margin: 0, fontSize: '12px', color: COLORS.textMuted, lineHeight: 1.6 }}>
          Peer-to-peer live streaming is in the works. Stay tuned.
        </p>
      </div>
    </div>
  );
}
